export enum ActionTypes {
  NAVIGATED_INSIDE_THE_APP = 'NAVIGATED_INSIDE_THE_APP',
  ELEMENT_ID_IN_VIEWPORT_UPDATED = 'ELEMENT_ID_IN_VIEWPORT_UPDATED'
}

type NavigatedInsideApp = {
  type: ActionTypes.NAVIGATED_INSIDE_THE_APP;
  payload: {
    prevUrl: string;
    currentUrl: string;
  };
};

type elementIdInViewPortUpdated = {
  type: ActionTypes.ELEMENT_ID_IN_VIEWPORT_UPDATED;
  payload: {
    elementIdInViewport: string;
  };
};

export type NavigationActionTypes = NavigatedInsideApp | elementIdInViewPortUpdated;
